import { MEMBER_PROFILE_CARD_ROUTER, MEMBER_PROFILE_ROUTER, MEMBER_PROFILE_WORKOUT_ROUTER, MEMBER_SMART_FITNESS_BAND_ROUTER } from "@Router/routerPath";
import { MemberPage, MemberCardPage, MemberWorkoutPage, SmartFitnessBandPage  } from "@Local/Member";

const MemberProfileRouter = [
    {
        description: '會員運動卡片',
        static: true,
        path: MEMBER_PROFILE_CARD_ROUTER,
        href: MEMBER_PROFILE_CARD_ROUTER,
        as: MemberCardPage,
    },
    {
        description: '會員運動次數',
        static: true,
        path: MEMBER_PROFILE_WORKOUT_ROUTER,
        href: MEMBER_PROFILE_WORKOUT_ROUTER,
        as: MemberWorkoutPage,
    },
    {
        description: '會員智能系統',
        static: true,
        path: MEMBER_SMART_FITNESS_BAND_ROUTER,
        href: MEMBER_SMART_FITNESS_BAND_ROUTER,
        as: SmartFitnessBandPage,
    },
    {
        description: '會員運動卡片',
        static: true,
        path: MEMBER_PROFILE_ROUTER,
        href: MEMBER_PROFILE_ROUTER,
        as: MemberPage,
    },
];

export default MemberProfileRouter;
